import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=f64d09c0&scoped=true"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"
import style0 from "./Expense.vue?vue&type=style&index=0&id=f64d09c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64d09c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64d09c0')) {
      api.createRecord('f64d09c0', component.options)
    } else {
      api.reload('f64d09c0', component.options)
    }
    module.hot.accept("./Expense.vue?vue&type=template&id=f64d09c0&scoped=true", function () {
      api.rerender('f64d09c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/expenses/components/quick_assignment/Expense.vue"
export default component.exports